export interface RentReviewOverallStatus {
  statusLabel: 'Not Started' | 'In Progress' | 'Completed';
  statusKey: 'not_started' | 'in_progress' | 'completed';
  statusCode: number; // 0: Not Started, 4: In Progress, 1: Completed
  description: string;
}

const hasCompletedTenancy = (flowInfo: any) => {
  return flowInfo?.is_completed; 
};

const isNhaFlow = (flowInfo: any) =>
  Boolean(
    flowInfo?.draft_agreement_type?.toLowerCase() === 'nha' ||
      flowInfo?.is_nha_generated ||
      flowInfo?.nha_contract_url ||
      flowInfo?.is_nha ||
      flowInfo?.agreement_type?.toLowerCase() === 'nha',
  );

/**
 * Common status check function for Rent Review:
 * - If there are no records (active is null, past and archive are empty/null) => 'Not Started'
 * - If there is an active record => 'In Progress'
 * - If there is no active record, but there are past or archived records => 'Completed'
 */
export const getRentReviewOverallStatus = (rentReviewData: any): RentReviewOverallStatus => {
  if (!rentReviewData) {
    return {
      statusLabel: 'Not Started',
      statusKey: 'not_started',
      statusCode: 0,
      description: 'You do not have any active rent review request.',
    };
  }

  const active = rentReviewData?.data?.active || rentReviewData?.active;
  const past = rentReviewData?.data?.past || rentReviewData?.past || [];
  const archive = rentReviewData?.data?.archive || rentReviewData?.archive || [];

  const hasActive = Boolean(active);
  const hasPast = Array.isArray(past) && past.length > 0;
  const hasArchive = Array.isArray(archive) && archive.length > 0;

  if (hasActive) {
    return {
      statusLabel: 'In Progress',
      statusKey: 'in_progress',
      statusCode: 4,
      description: 'You have a pending rent review request.',
    };
  }

  if (hasPast || hasArchive) {
    return {
      statusLabel: 'Completed',
      statusKey: 'completed',
      statusCode: 1,
      description: 'Your rent review is completed.',
    };
  }

  return {
    statusLabel: 'Not Started',
    statusKey: 'not_started',
    statusCode: 0,
    description: 'You do not have any active rent review request.',
  };
};

export const shouldShowRentReviewEntryPoints = (flowInfo: any) =>
  hasCompletedTenancy(flowInfo) && !isNhaFlow(flowInfo);
